import {
    trackBeginCheckout,
    trackCartAction,
    trackCartView,
    trackCouponCodeFailure,
    trackCtaAction,
    trackPageView,
    trackPaymentInfo,
    trackReviewSubmit,
    trackSearch,
    trackShippingInfo,
    trackViewPdp,
} from './events-handlers'
import { identify, logout, setUserAttributes, signup } from './identify-handlers'

export const Webengage = {
    identify,
    logout,
    signup,
    setUserAttributes,
    trackPageView,
    trackSearch,
    trackViewPdp,
    trackReviewSubmit,
    trackShippingInfo,
    trackCartView,
    trackCouponCodeFailure,
    trackBeginCheckout,
    trackPaymentInfo,
    trackCartAction,
    trackCtaAction,
}
